export class PriceRequest {
  unit_amount: number;

  constructor(price: number) {
    this.unit_amount = price * 100;
  }
}
